import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledOCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${toRem(16)}; /* --space-large */
  padding: ${toRem(32)}; /* --card-margin-large horizontal, --space-x-large vertical */
  background: ${baseVariables?.color?.white || '#ffffff'}; /* --background/cardbackground */
  border: 1px solid ${baseVariables?.color?.neutral10 || '#eeeeee'}; /* --border/cardborderdefault */
  border-radius: ${toRem(14)}; /* --radius/borderradius-card-default */
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07); /* Light/Shadow-02 */
  width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* overflow-clip from Figma */

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1 0 0; /* flex-[1_0_0] */
    min-width: 0;
    gap: ${toRem(8)}; /* --space-medium */

    .title-text {
      /* Subtitle/Large typography style */
      font-family: ${theme.fonts?.fontFamilySwiss ||
      "'Swiss721_BT', sans-serif"}; /* --typography/subtitle-font-family */
      font-weight: 700; /* --typography/subtitle-xl-font-weight: bold/medium */
      font-size: ${toRem(18)}; /* --typography/t-subtitle-l-font-size */
      line-height: 1.25; /* leading-[1.25] */
      letter-spacing: 0;
      color: ${baseVariables?.color?.neutral100 || '#1c1c1c'}; /* --text/defaulttext */
      margin: 0;
      width: 100%;
    }
  }

  /* Anchor wrapper for the button */
  .search-all-button-link {
    text-decoration: none;
    display: inline-block;
    flex-shrink: 0;
  }

  /* Button follows Medium size styling from Figma */
  .search-all-button {
    flex-shrink: 0; /* shrink-0 */
    min-height: ${toRem(40)} !important; /* min-h-[40px] for Medium size */
    min-width: ${toRem(100)} !important; /* min-w-[100px] for Medium size */
    padding: 0 ${toRem(16)} !important; /* px-[var(--general/spacer-03,16px)] */

    white-space: nowrap;
    cursor: pointer;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    /* Ensure text inside button matches Figma */
    span,
    p,
    div {
      font-family: 'Swiss721_BT', sans-serif !important;
      font-weight: 700 !important;
      font-size: ${toRem(16)} !important;
      line-height: 1 !important;
      color: ${baseVariables?.color?.white || '#ffffff'} !important;
      margin: 0 !important;
    }
  }

  /* Tablet - maintain horizontal layout */
  @media ${baseVariables.mediaQuery.md} {
    padding: ${toRem(24)} ${toRem(28)}; /* Slightly reduce padding */
    gap: ${toRem(12)};

    .content-wrapper {
      .title-text {
        font-size: ${toRem(16)}; /* Slightly smaller on tablet */
      }
    }

    .search-all-button {
      min-height: ${toRem(38)};
      font-size: ${toRem(15)};
      padding: 0 ${toRem(14)} !important;
    }
  }

  /* Only switch to vertical layout on very small mobile screens */
  @media (max-width: 480px) {
    flex-direction: column;
    text-align: center;
    gap: ${toRem(16)};
    padding: ${toRem(20)} ${toRem(16)};

    .content-wrapper {
      align-items: center;

      .title-text {
        text-align: center;
        font-size: ${toRem(16)};
      }
    }

    .search-all-button {
      width: 100%;
      max-width: ${toRem(240)}; /* Wider on mobile for better touch target */
    }
  }
`;
